import { MutationTree } from 'vuex'

import { UserState } from './types'

const mutations: MutationTree<UserState> = {
  set: (state, { user, unlisten }) => {
    state.data.unlisten && state.data.unlisten()
    state.data.user = user
    state.data.unlisten = unlisten
  },

  loading: state => {
    state.data.loading = true
  },

  loaded: state => {
    state.data.loading = false
  },

  update: (state, user) => {
    if (state.data.user) state.data.user = user
  },

  signout: state => {
    state.data.unlisten && state.data.unlisten()
    state.data.user = undefined
  }
}

export default mutations
